<div class="m-3">
  <!-- CLIENT ADMINS -->
  <div class="d-flex justify-content-between mb-2">
    <p translate>customer.clientAdmins</p>
    <div class="search-header d-flex">
      <div class="add-button-container">
        <button class="custom-button add-button" (click)="onAddAdmin()" translate>customer.addClientAdmin<i
            class="fa fa-plus ml-2"></i></button>
      </div>
    </div>
  </div>
  <div style="text-align: center; padding: 24px;" *ngIf="clientAdmins && !clientAdmins?.results.length">
    <p translate>customer.noAdminsFound</p>
  </div>

  <div *ngIf="clientAdmins && clientAdmins?.results.length" class="row">
    <div class="col-xl-3-custom col-lg-4 col-md-6 col-sm-12" *ngFor="let user of clientAdmins?.results">

      <!-- Card: Catcher -->
      <div class="card card-widget widget-user" [class.dark-mode]="darkMode">
        <!-- Add the bg color to the header using any of the bg-* classes -->
        <div class="widget-user-header bg-info-active">
          <div class="edit-container">
            <div class="dropdown" style="text-align: right;">
              <button class="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
              </button>

              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" style="cursor: pointer;" (click)="onOpenDMS(user)"
                  translate>global.interfaces</a>
                <a class="dropdown-item" style="cursor: pointer;" (click)="onEditAdmin(user)"
                  translate>global.edit</a>
                <a class="dropdown-item" style="cursor: pointer;"
                  (click)="showDialogDeleteAdmin(dialogDeleteAdmin, user)" translate>global.delete</a>
              </div>
            </div>
          </div>
          <h3 class="widget-user-username">{{ user?.name }}</h3>
        </div>
        <div class="picture">
          <div class="widget-image">
            <div *ngIf="user.profilePicture" class="img-circle elevation-2 profile-picture user-icon"
              [style.background-image]="'url(' + user.profilePicture.path + ')'">
            </div>
            <i *ngIf="!user.profilePicture" class="fa fa-user user-icon"></i>
          </div>
        </div>
        <div class="card-info1 mb-3">
          <p class="email" style="text-align: center; font-size: 1rem; margin: 8px 0 0 0 ;">{{user?.email}}</p>
          <!-- /.row -->
        </div>
      </div>
      <!-- /.widget-user -->

    </div>
  </div>
  <div class="clearfix" style="width: 100%"></div>

  <ngb-pagination [collectionSize]="clientAdmins?.count" [(pageSize)]="adminPerPage" [(page)]="adminPage"
    [maxSize]="5" [rotate]="true" (pageChange)="jumpToAdminPage($event)"></ngb-pagination>
  <!-- / .CLIENT ADMINS -->
</div>


<app-modal (close)="toggleAddClientAdmin = !toggleAddClientAdmin" *ngIf="toggleAddClientAdmin">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>customer.newClientAdmin</p>

    <form #userForm="ngForm" class="form-vehicle">

      <!-- Name -->
      <div class="form-group">
        <label translate>customer.fullName</label>
        <input type="text" #fullName="ngModel" autocomplete="off" required [ngModel]="clientAdmin.name"
          class="form-control" [class.is-invalid]="fullName.invalid && fullName.touched" name="fullName">
      </div>

      <!-- Email -->
      <div class="form-group">
        <label translate>customer.email</label>
        <input type="email" #email="ngModel" autocomplete="off" required [ngModel]="clientAdmin.email"
          class="form-control" [class.is-invalid]="email.invalid && email.touched" name="email">
      </div>

      <!-- Password -->
      <div *ngIf="clientAdmin.isNew" class="form-group">
        <label translate>customer.password</label>
        <input type="text" #password="ngModel" autocomplete="off" required ngModel class="form-control"
          [class.is-invalid]="password.invalid && password.touched" name="password">
      </div>

      <!-- Password Repeat -->
      <div *ngIf="clientAdmin.isNew" class="form-group">
        <label translate>customer.repeatPassword</label>
        <input type="text" #passwordRepeat="ngModel" autocomplete="off" required ngModel class="form-control"
          [class.is-invalid]="passwordRepeat.invalid && passwordRepeat.touched" name="passwordRepeat">
      </div>

      <div style="min-height: 24px;"></div>

      <button type="submit" class="custom-button" *ngIf="clientAdmin.isNew" (click)="addClientAdmin(userForm)"
        style="width: 120px;" translate>global.save</button>
      <button class="custom-button w-100" *ngIf="!clientAdmin.isNew" (click)="editAdmin(userForm)"
        translate>global.edit</button>

    </form>
  </div>
</app-modal>

<!--Delete client admin-->
<ng-template #dialogDeleteAdmin let-c="close" let-d="dismiss">
  <div class="modal-body">
    <div class="row">
      <p translate>customer.deleteClientAdminInfo</p>
      <!-- <p translate>customer.deleteUserMessage</p> -->
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteClientAdmin()"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

<app-modal *ngIf="toggleDmsModal" (close)="toggleDmsModal = false">
  <div style="min-height: 500px; padding: 12px; letter-spacing: 1px; color: #000; text-align: initial;">
    <app-interface-setup [userId]="selectedAdmin.id" [currentUser]="currentUser"></app-interface-setup>
  </div>
</app-modal>